import Service from '@ember/service';

import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import ENV from 'rise-ui/config/environment.js';
import { minDate, maxDate } from 'rise-ui/config/time-series/query-params.js';
import { formatDate, parseDate } from 'rise-ui/utils/date.js';
import { join } from 'rise-ui/utils/string.js';
import { isSet } from 'rise-ui/utils/nullish.js';
import { encodeArray } from 'rise-ui/utils/query-params.js';

const API = ENV.APP.API.DATA;

/**
 * Queries/serializes location-filters for time-series routes
 * @name LocationFiltersModelService
 */
export default class TimeSeriesDownloadAllService extends Service {
  @service('time-series/graph-results') graphResults;

  host = API.EXPOSED_URL;
  namespace = API.NAMESPACE;
  endpoint = 'result/downloadall';

  @cached get url() {
    const { endpoint, host, namespace } = this;
    return join([host, namespace, endpoint], '/');
  }
  @cached get query() {
    const date = date => formatDate(parseDate(date), 'short');
    const query = [];
    this.graphResults.outputs.forEach(({ dates, output }) => {
      const { modelName } = output?.constructor || {};
      if (!modelName || !dates) {
        return;
      }
      const isItem = modelName === 'item';
      const { from, to } = dates;
      query.push({
        [isItem ? 'itemId' : 'modelRunId']: output.id,
        before: to && to !== minDate ? date(to) : undefined,
        after: from && from !== maxDate ? date(from) : undefined,
        order: 'ASC',
      });
    });
    return encodeArray(query, { escape: '' });
  }

  link(options) {
    options = options || {};
    let { filename, type, disposition } = options;
    const { query } = this;
    if (!filename || !type || !query || !query.length) {
      return;
    }
    const qps = {
      'query[]': query,
      type,
      filename: encodeURIComponent(filename),
      order: 'ASC',
      disposition,
    };
    return this.url + '?' + Object.entries(qps)
      .filter(([k, v]) => isSet(k) && isSet(v))
      .map(([k, v]) => [].concat(v).map(v => `${k}=${v}`).join('&')).join('&');
  }

  getUrl(options) {
    return this.link(options) || 'javascript:void(0)';
  }
}
